// TODO replace!!!!
import type { Organization } from '@innovamat/glow-api-client';

const DEFAULT_TIMEZONE = 'Europe/Madrid';

const getTimezone = (organization: Organization): string => {
  return organization.timezone || DEFAULT_TIMEZONE;
};

export { getTimezone };
